import { UIView, useCurrentStateAndParams } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";

import { PageTopBanner } from "app/components/PageTopBanner/PageTopBanner";
import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";
import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";

import { MarketResearchWrapperContainer } from "./styleComponents";

export const MarketResearchWrapper = ({ shouldLogErrorFallback }) => {
    const autoScrollRef = useAutoScrollTop();
    const { params, state } = useCurrentStateAndParams();

    return (
        <div className="sw-layout-module-inner">
            <MarketResearchWrapperContainer className="u-flex-row u-flex-column">
                <div
                    className="sw-layout-no-scroll-container sw-layout-research disable-top-padding use-sticky-css-rendering fadeIn"
                    ref={autoScrollRef}
                >
                    <ErrorBoundary
                        FallbackComponent={(props) => (
                            <ErrorFallback
                                {...props}
                                shouldLogErrorFallback={shouldLogErrorFallback}
                            />
                        )}
                        resetKeys={[state, params]}
                    >
                        <PageTopBanner />
                        <UIView />
                    </ErrorBoundary>
                </div>
            </MarketResearchWrapperContainer>
        </div>
    );
};
